module.exports = __webpack_public_path__ + "12f9f2ebb5d19e474d724e9382c948eb.png";